<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-pen
      </v-icon> Update Blog
    </h2>
    <v-card color="#fff">
      <br>
      <v-col class="text-right">
        <v-btn
          color="dark red"
          @click="updateBlog()"
        >
          Update
        </v-btn>
        <v-btn
          color="red darken-3"
          @click="goBack()"
        >
          Cancel
        </v-btn>
      </v-col>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="9"
          >
            <v-text-field
              v-model="name"
              label="Title*"
              hint="Name for your reference - 'DBSystems'."
              :rules="[(v) => !!v || 'This field is required']"
              outlined
              type="text"
              dense
              @input="createSlug()"
            />
            <div
              ref="quillEditor"
              style="height: 600px"
              class="mb-4"
              @ready="onEditorReady($event)"
            />
          </v-col>
          <v-col
            cols="12"
            lg="3"
          >
            <h5>
              Meta Title <font color="red">
                *
              </font> <code>{{ metaTitle.length }}/60</code>
            </h5>
            <v-text-field
              v-model="metaTitle"
              maxlength="60"
              :rules="[(v) => !!v || 'This field is required']"
              outlined
              dense
            />
            <h5>
              Meta Description<font color="red">
                *
              </font> <code>{{ metaDescription.length }}/160</code>
            </h5>
            <v-textarea
              v-model="metaDescription"
              maxlength="160"
              outlined
              dense
            />
            <h5>
              Category <font color="red">
                *
              </font>
            </h5>
            <v-select
              v-model="category"
              :items="categoriesList"
              :rules="[(v) => !!v || 'This field is required']"
              item-text="name"
              item-value="id"
              type="text"
              outlined
              dense
            />
            <v-btn
              x-small
              @click="openFormToCreateCategory"
            >
              + Add new Category
            </v-btn>
            <h5>
              Tags <font color="red">
                *
              </font>
            </h5>
            <v-select
              v-model="tags"
              outlined
              dense
              :items="filteredTags"
              multiple
              item-text="name"
              item-value="id"
            />
            <v-btn
              x-small
              @click="openFormToCreateTag"
            >
              + Add new tags
            </v-btn><span
              v-for="tag in blogDetails.tags"
              :key="tag.id"
            >
              <v-chip
                x-small
                outlined
                @click="deleteTag(tag)"
              >
                {{ tag.name }}<span><v-icon
                  small
                >mdi-close</v-icon>
                </span></v-chip>

            </span>
            <h5>
              Slug <font color="red">
                *
              </font>
            </h5>
            <v-text-field
              v-model="slug"
              outlined
              dense
            />
            <h5>Reading Time</h5>
            <v-text-field
              v-model="readingTime"
              disabled
              type="number"
              outlined
              dense
            />
            <h5>
              CTA Title <font color="red">
                *
              </font>
            </h5>
            <v-text-field
              v-model="ctaTitle"
              :rules="[(v) => !!v || 'This field is required']"
              type="text"
              outlined
              dense
            />
            <h5>E Book</h5>
            <v-file-input
              ref="file"
              v-model="ebook"
              show-size
              color="#000000"
              prepend-icon=""
              style="margin-bottom: 10px"
              background-color="transparent"
              dense
              light
              class="ma-0 pa-0 upload-box"
              :prepend-inner-icon="removeEbookIcon"
              elevation="0"
              solo
              flat
              accept=".pdf"
            />
            <span v-if="ebook === null">{{ pdfName }}</span>
            <h5>
              Feature Image <font color="red">
                *
              </font>
            </h5>
            <v-file-input
              ref="file"
              v-model="featureImage"
              show-size
              color="#000000"
              prepend-icon=""
              style="margin-bottom: 10px"
              background-color="transparent"
              dense
              light
              class="ma-0 pa-0 upload-box"
              :prepend-inner-icon="removeIcon"
              elevation="0"
              solo
              flat
              accept=".jpg,.jpeg,.png,.webp"
              @change="onFileChange"
              @click:clear="imageUrl = ''"
            />
            <div class="image-container">
              <v-img :src="imageUrl" />
            </div>
            <br>
          </v-col>
        </v-row>
        <br>
      </v-card-title>
    </v-card>
    <centre-spinner :loading="loading" />
    <create-tags
      v-if="showTagForm"
      @closed="showTagForm = false"
    />
    <create-category
      v-if="showCategoryForm"
      @confirmed="closeCategory()"
      @closed="showCategoryForm = false"
    />
    <delete-dialog
      v-if="showDeleteDialog"
      @closed="showDeleteDialog = false"
      @confirmed="confirmTagDelete()"
    />
  </v-container>
</template>
<script>
  import Quill from 'quill';
  import 'quill/dist/quill.snow.css';
  import CreateTags from './CreateTags.vue';
  import CreateCategory from './CreateCategory.vue';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';
  import { storageUrl } from 'src/app-globals';
  import DeleteDialog from '../component/DeleteDialog.vue';

  export default {
    components: {
      'create-tags': CreateTags,
      'create-category': CreateCategory,
      'centre-spinner': spinner,
      'delete-dialog': DeleteDialog,
    },
    data () {
      return {
        quill: null,
        content: '',
        featureImage: null,
        tags: [],
        showTagForm: false,
        imageUrl: '',
        slug: '',
        metaDescription: '',
        metaTitle: '',
        readingTime: '',
        showCategoryForm: false,
        loading: false,
        name: '',
        category: '',
        title: '',
        ebook: null,
        showDeleteDialog: false,
        tagForDelete: null,
        pdfURL: null,
        pdfName: null,
      };
    },
    computed: {
      removeIcon (id) {
        if (this.featureImage === null) {
          return 'mdi-cloud-upload';
        } else {
          return '';
        }
      },
      removeEbookIcon (id) {
        if (this.ebook === null) {
          return 'mdi-cloud-upload';
        } else {
          return '';
        }
      },
      tagsList () {
        return this.$store.getters['blogs/getTags'];
      },
      filteredTags () {
        if (this.blogDetails.length !== 0 && Array.isArray(this.blogDetails.tags)) {
          return this.tagsList.filter(
            tag => !this.blogDetails.tags.some(item => item.id === tag.id),
          );
        } else {
          return [];
        }
      },
      categoriesList () {
        return this.$store.getters['blogs/getCategories'];
      },
      blog () {
        return this.$store.getters['blogs/getBlog'];
      },
      blogDetails () {
        return this.$store.getters['blogs/getBlogDetails'];
      },
    },
    watch: {
      content (newVal, oldVal) {
        this.generateReadingTime();
      },
    },
    async mounted () {
      this.loading = true;
      this.quill = new Quill(this.$refs.quillEditor, {
        theme: 'snow',
        placeholder: 'Blog starts here..',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ header: [1, 2, 3, false] }],
            ['link', 'image', 'video', 'code'],
            [{ align: [] }],
          ],
        },
      });
      this.quill.on('text-change', () => {
        this.content = this.quill.root.innerHTML;
      });
      await this.fetchTags();
      await this.fetchCategories();
      await this.loadOnMount();
      this.loading = false;
    },
    methods: {
      openFormToCreateTag () {
        this.showTagForm = true;
      },
      async loadOnMount () {
        await this.fetchBlogDetails().then(() => {
          this.name = this.blogDetails.blog.title;
          this.metaDescription = this.blogDetails.blog.description;
          this.metaTitle = this.blogDetails.blog.meta_title;
          this.readingTime = this.blogDetails.blog.reading_time;
          this.quill.root.innerHTML = this.blogDetails.blog.content;
          this.category = this.blogDetails.blog.category.id;
          this.tagsListing = this.blogDetails.tags;
          this.slug = this.blogDetails.blog.slug;
          this.ctaTitle = this.blogDetails.blog.banner;
          if (this.blogDetails.blog.pdf_file !== null) {
            this.pdfName = this.blogDetails.blog.pdf_file.original_file_name;
          }
          if (this.blogDetails.blog.preview_content !== null) {
            this.imageUrl = storageUrl + this.blogDetails.blog.preview_content.file_path;
          }
        });
      },
      async fetchTags () {
        await this.$store.dispatch('blogs/fetchTags', {
          resourceType: 'blog',
        });
      },
      async fetchCategories () {
        await this.$store.dispatch('blogs/fetchCategories', {
          resourceType: 'blog',
        });
      },
      createImage (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      },
      onFileChange (file) {
        if (!file) {
          return;
        }
        this.createImage(file);
      },
      openFormToCreateCategory () {
        this.showCategoryForm = true;
      },
      async closeCategory () {
        this.showCategoryForm = false;
        await this.fetchCategories();
      },
      async fetchBlogDetails () {
        await this.$store.dispatch('blogs/fetchBlogDetails', {
          id: this.$route.params.id,
        });
      },
      async updateBlog () {
        if (this.metaTitle.length > 60) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Maximun 60 character is allowed for meta title',
            type: Constants.ALERT_TYPE_ERROR,
          });
          return;
        }
        if (this.metaDescription.length > 160) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Maximum 160 character is allowed for meta description',
            type: Constants.ALERT_TYPE_ERROR,
          });
          return;
        }
        this.loading = true;
        await this.$store
          .dispatch('blogs/updateBlog', {
            details: {
              title: this.name,
              description: this.metaDescription,
              meta_title: this.metaTitle,
              content: [this.content],
              reading_time: this.readingTime.toString(),
              slug: this.slug,
              category: this.category,
              tags: this.tags,
              banner: this.ctaTitle,
            },
            id: this.blogDetails.blog.id,
          })
          .then(() => {
            if (this.ebook !== null) {
              this.uploadEBook();
            };
            if (this.featureImage !== null) {
              this.uploadFeatureImage();
            } else {
              this.$router.push('/blogs');
            }
            this.$store.dispatch('alert/onAlert', {
              message: 'Blog updated successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
        this.loading = false;
      },
      async uploadFeatureImage () {
        this.loading = true;
        const formData = new FormData();
        formData.append('file', this.featureImage);
        formData.append('type', 'preview');
        await this.$store.dispatch('blogs/uploadFile', {
          documentDetails: formData,
          id: this.blogDetails.blog.id,
        });
        this.$router.push('/blogs');
      },
      async uploadEBook () {
        this.loading = true;
        const formData = new FormData();
        formData.append('file', this.ebook);
        formData.append('type', 'pdf');
        await this.$store
          .dispatch('blogs/uploadFile', {
            documentDetails: formData,
            id: this.blogDetails.blog.id,
          });
        this.loading = false;
      },
      createSlug () {
        this.slug = this.name.replace(/[\s,:;]+/g, '-').toLowerCase();
      },
      deleteTag (val) {
        this.tagForDelete = val;
        this.showDeleteDialog = true;
      },
      async confirmTagDelete () {
        this.loading = true;
        this.showDeleteDialog = false;
        await this.$store.dispatch('blogs/deleteBlogTag', {
          blogId: this.blogDetails.blog.id,
          tagId: this.tagForDelete.id,
        }).then(() => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Tag deleted successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.showDeleteDialog = false;
          this.loading = true;
          this.fetchBlogDetails();
          this.loading = false;
        });
        this.showDeleteDialog = false;
      },
      goBack () {
        this.$router.push('/blogs');
      },
      generateReadingTime () {
        const wpm = 238;
        const words = this.quill.root.innerText.trim().split(/\s+/).length;
        this.readingTime = Math.ceil(words / wpm);
      },
      async removePdf () {
        this.loading = true;
        await this.$store.dispatch('blogs/removeBlogPdf', {
          id: this.blogDetails.blog.pdf_file.id,
        }).then(() => {
          this.loading = true;
          this.pdfName = null;
        }).catch(() => {
          this.loading = true;
        });
        this.loading = false;
      },
    },
  };
</script>

<style>
.output {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
}

.title-style {
  color: #37474f;
  margin-left: 20px;
}

.icon-style {
  color: #37474f;
  font-size: 45px;
}

.v-file-input >>> .v-file-input__text {
  justify-content: center !important;
}

.v-file-input >>> .v-input__slot {
  height: 100px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.upload-box {
  border: 1px dashed black;
  border-radius: 10px;
}

.v-file-input >>> .v-icon {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.v-file-input >>> .mdi-close {
  position: absolute;
  top: 40%;
  left: 94%;
  transform: translate(-50%, -50%);
}

.v-text-field__details {
  display: none;
}

.v-input__slot .transparent {
  position: relative;
}

.v-input__prepend-inner {
  position: absolute;
  left: 45%;
}
.image-container {
  width: 100%;
  padding-top: 10px;
}
.v-image {
  width: 300px;
}
code {
  float: right;
  padding: 0px!important;

}
.theme--light.v-application code{
  background-color: #fff;
}
</style>
